/** Strips a leading `#` and whitespace. Empty / missing → undefined. */
export function nextStepIdFromHash(hash: string | null | undefined): string | undefined {
    const nextStepId = hash?.replace(/^#/, '').trim()
    return nextStepId || undefined
}
